import { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const PositiveIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;

  return (
    <svg viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons/Gene-Story/Positive">
          <circle id="Oval" fill="#82BECC" cx="20" cy="20" r="20" />
          <polyline
            id="Line-3-Copy"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(20.000000, 20.833333) scale(-1, 1) translate(-20.000000, -20.833333) "
            points="10.8333333 14.1666667 23.0555556 27.5 29.1666667 20.8333333"
          />
        </g>
      </g>
    </svg>
  );
};
